import { Button, Indicator, Modal, Tooltip } from "@mantine/core";
import { IconRocket } from "@tabler/icons-react";
import moment from "moment";
import { useEffect, useState } from "react";
import snarkdown from "snarkdown";
import { useLocalStorage } from "usehooks-ts";
import { doGetReleaseNotes } from "./routes/admin/restQueries";

const ReleaseNotesButton = () => {
  const [openReleaseNotesTimeStamp, setOpenReleaseNotesTimeStamp] = useLocalStorage<string | null>(
    "releaseNotesLastOpen",
    null,
  );

  const onClickReleaseNotesTimeStamp = () => {
    setOpenReleaseNotesTimeStamp(moment().format());
  };
  const [showReleaseNotesModal, setShowReleaseNotesModal] = useState<boolean>(false);
  const [releaseNotesText, setReleaseNotesText] = useState<string>("");
  const [releaseNotes, setReleaseNotes] = useState<string>("");
  const [animate, setAnimate] = useState<boolean>(false);

  useEffect(() => {
    getReleaseNotes();
  }, []);

  const getReleaseNotes = async () => {
    try {
      const _releaseNotes = await doGetReleaseNotes();
      setReleaseNotes(_releaseNotes);
      const hasNewNotes = hasNewReleaseNotes(_releaseNotes);
      setAnimate(hasNewNotes);
    } catch (error) {
      console.error("Error fetching release notes:", error);
    }
  };

  const hasNewReleaseNotes = (_releaseNotes: string) => {
    const extractedLastDateFromReleaseNotes = _releaseNotes.match(/(\d{2})\.(\d{2})\.(\d{4})/);

    if (extractedLastDateFromReleaseNotes) {
      const [_, day, month, year] = extractedLastDateFromReleaseNotes;
      const extractedDate = `${year}-${month}-${day}`;
      const extractedDateObj = new Date(extractedDate);
      const lastOpenedDate = new Date(openReleaseNotesTimeStamp);

      return extractedDateObj > lastOpenedDate;
    }

    return false;
  };

  const showReleaseNotes = async (): Promise<void> => {
    onClickReleaseNotesTimeStamp();
    setShowReleaseNotesModal(!showReleaseNotesModal);
    setReleaseNotesText(snarkdown(releaseNotes));
    setAnimate(false);
  };

  return (
    <>
      <Tooltip label="Vis versjonshistorikk" withArrow>
        <Indicator disabled={!animate} inline size={10} offset={7} position="top-start" color="orange.5">
          <Button c={"white"} size="compact-xl" variant="subtle" onClick={showReleaseNotes}>
            <IconRocket size={20} />
          </Button>
        </Indicator>
      </Tooltip>
      <Modal
        size="60%"
        style={{ maxWidth: "60vw", maxHeight: "90%" }}
        opened={showReleaseNotesModal}
        onClose={() => setShowReleaseNotesModal(!showReleaseNotesModal)}
        title={"Versjonshistorikk"}
      >
        <div dangerouslySetInnerHTML={{ __html: releaseNotesText }} />
      </Modal>
    </>
  );
};

export default ReleaseNotesButton;
